import PropTypes from 'prop-types';
import React from 'react';
import './Select.scss';

function Select(props) {
  function onChange(event) {
    props.onChange(event.target.value);
  }

  return (
    <select
      {...props}
      value={props.value}
      onChange={onChange}
      className={`pencil-select ${props.className}`}
    >
      {props.children}
    </select>
  );
}

Select.propTypes = {
  value: PropTypes.any,
  options: PropTypes.array,
  onChange: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.any,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
};

Select.defaultProps = {
  value: '',
  onChange: () => {},
  className: '',
};

function Option(props) {
  return <option value={props.value}>{props.name}</option>;
}

Option.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
};

Select.Option = Option;

export default Select;
